module.exports = __webpack_public_path__ + "img/seamsi2.30eee703.png";